import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ForgotPasswordModal from '../../components/auth/ForgotPasswordModal';

function MobileSiginUp() {
    const agentCode = localStorage.getItem('agent_code');
    const referralCode = localStorage.getItem('referral_code') || localStorage.getItem('affiliate_code');
    const [formData, setFormData] = useState(() => {
      const hostname = (window.location.hostname || '').toLowerCase();
      const origin = (window.location.origin || '').toLowerCase();
      const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();
      const isRocket88 = hostname.includes('rocket88') || origin.includes('rocket88') || brand.includes('rocket88');
      return {
        username: '',
        password: '',
        session_id: isRocket88 ? 0 : 1,
        force_phone: 1,
        name: '',
        phone: '',
        email: '',
        dofb: '1995-12-04',
        agent_code: agentCode || '',
        referral_code: referralCode || '',
        currency: 'BDT',
        status: 'active',
      };
    });
  const [showMobile, setShowMobile] = useState(true);
  const [isTk24, setIsTk24] = useState(false);
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordRules, setPasswordRules] = useState({
      hasUppercase: false,
      hasLowercase: false,
      hasNumber: false,
      hasMinLength: false
    });
  const [dialog, setDialog] = useState({ open: false, type: 'info', message: '' });
  const [showForgot, setShowForgot] = useState(false);
  const openDialog = (type, message) => setDialog({ open: true, type, message });
  const closeDialog = () => setDialog({ open: false, type: 'info', message: '' });

    const pickExchangeToken = (obj) => {
      if (!obj || typeof obj !== 'object') return '';
      try {
        return (
          obj.exchange?.[0]?.token ??
          obj.exchange?.token ??
          obj.exchange_token ??
          obj.exchangeToken ??
          obj.data?.exchange?.[0]?.token ??
          obj.data?.exchange_token ??
          ''
        );
      } catch (_) { return ''; }
    };

    const normalizeErrorValue = (v) => Array.isArray(v) ? (v[0] ?? '') : (v ?? '');
    const normalizeErrorObject = (obj) => {
      if (!obj || typeof obj !== 'object') return {};
      const out = {};
      Object.entries(obj).forEach(([k, v]) => { out[k] = normalizeErrorValue(v); });
      return out;
    };
    const formatErrorList = (obj) => {
      if (!obj || typeof obj !== 'object') return '';
      return Object.entries(obj)
        .filter(([_, v]) => v)
        .map(([field, msg]) => `${field}: ${normalizeErrorValue(msg)}`)
        .join('\n');
    };
   
    useEffect(() => {
      // Brand detection: hostname, origin and env/localStorage brand
      const hostname = (window.location.hostname || '').toLowerCase();
      const origin = (window.location.origin || '').toLowerCase();
      const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

      const isTk24Origin = hostname.includes('tk24') || origin.includes('tk24') || brand.includes('tk24');
      setIsTk24(isTk24Origin);

      // Always show mobile by default for all origins
      setShowMobile(true);
    }, []);

    useEffect(() => {
        if (agentCode) {
            setFormData(prevData => ({ ...prevData, agent_code: agentCode }));
        }
        if (referralCode) {
            setFormData(prevData => ({ ...prevData, referral_code: referralCode }));
        }
    }, [agentCode, referralCode]);

    const togglePasswordVisibility = () => setPasswordShown(!passwordShown);
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        
        // Update password validation rules in real-time
        if (name === 'password') {
          setPasswordRules({
            hasUppercase: /[A-Z]/.test(value),
            hasLowercase: /[a-z]/.test(value),
            hasNumber: /[0-9]/.test(value),
            hasMinLength: value.length >= 8
          });
        }
    };

  const validate = () => {
        let tempErrors = {};
        const usernamePattern = /^[a-zA-Z0-9]+$/;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phonePattern = /^[0-9]{10,15}$/;
        const passwordPattern = /^[a-zA-Z0-9]+$/; // Alphanumeric characters only (no special characters)

        // Username validation
        if (!formData.username) tempErrors.username = "Username is required";
        else if (!usernamePattern.test(formData.username)) tempErrors.username = "Invalid username (only letters and numbers)";

    if (formData.username.length < 4 || formData.username.length > 16) { 
      tempErrors.username = "Username must be between 4 and 16 characters";
    }

    // tk24: referral code is required
    if (isTk24 && !formData.agent_code) {
      tempErrors.agent_code = "Referral code is required";
    }

    // Phone validation (only when phone field is shown)
    if (showMobile) {
      if (!formData.phone) tempErrors.phone = "Mobile number is required";
      else if (!phonePattern.test(formData.phone)) tempErrors.phone = "Enter a valid mobile number";
    }

    // Optional email validation if provided
    if (formData.email) {
      if (!emailPattern.test(formData.email)) tempErrors.email = "Enter a valid email address";
    }


        // Password validation
        if (!formData.password) tempErrors.password = "Password is required";
        else if (formData.password.length < 8) tempErrors.password = "Password must be at least 8 characters";
        else if (!/[A-Z]/.test(formData.password)) tempErrors.password = "Password must contain at least 1 uppercase letter";
        else if (!/[a-z]/.test(formData.password)) tempErrors.password = "Password must contain at least 1 lowercase letter";
        else if (!/[0-9]/.test(formData.password)) tempErrors.password = "Password must contain at least 1 number";
        else if (!passwordPattern.test(formData.password)) tempErrors.password = "Password can only contain letters and numbers (no special characters)";

        // Confirm password validation
      

    // Persist normalized field errors
    setErrors(normalizeErrorObject(tempErrors));
    return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {

      window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'signup_button_click',
    category: 'User Signup',
    action: 'Click',
    label: 'Signup Button'
  });
        e.preventDefault();
    
        // Log formData before submitting
        console.log("Submitting formData:", formData);
    
  if (validate()) {
            try {
        // Universal payload for all origins
        // - Always include DOB (fallback to '2002-01-01')
        // - Always force phone collection flag as 1
        const resolvedDob = formData.dofb || '1995-12-04';
        const payload = {
          ...formData,
          dofb: resolvedDob,          // existing key used elsewhere in app
          dob: resolvedDob,           // duplicate for backend variants expecting 'dob'
          date_of_birth: resolvedDob, // cover APIs expecting 'date_of_birth'
          force_phone: 1,
        };
        console.log('[Signup] Payload about to submit:', payload);

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-players`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin,
                    },
          body: JSON.stringify(payload),
                    
                });
    
                // Parse response
                const data = await response.json();
    
                // Handle response status
                if (response.ok) {
                  openDialog('success', 'Registration successful. Logging in...');
                    // Auto login after signup
                    const loginResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            username: payload.username,
                            password: payload.password,
                        }),
                    });
                
                    const loginData = await loginResponse.json();
                
                    if (loginResponse.ok) {
                        // Save login data
                        localStorage.setItem('token', loginData.token);
                        localStorage.setItem('remote_id', loginData.remote_id);
                        localStorage.setItem('username', loginData.username);
                        // Prefer exchange token from login response; fallback to signup response
                        const exchangeToken = pickExchangeToken(loginData) || pickExchangeToken(data);
                        if (exchangeToken) {
                          localStorage.setItem('exchangeToken', exchangeToken);
                        } else {
                          localStorage.removeItem('exchangeToken');
                        }
                        localStorage.setItem('popup', 1);
						localStorage.setItem('regPopup', 1);
						
						localStorage.removeItem('agent_code');
                        localStorage.removeItem('referral_code');
                        localStorage.removeItem('affiliate_code');
                
                        // DOB already standardized; no brand-specific post-update required

                        // Ensure profile stores DOB using the authenticated profile update API
                        try {
                          const profileRes = await fetch(`${process.env.REACT_APP_API_URL}/api/user/profile/update`, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              'Authorization': `Bearer ${loginData.token}`,
                            },
                            body: JSON.stringify({
                              remote_id: loginData.remote_id,
                              dofb: resolvedDob,
                              dob: resolvedDob,
                            }),
                          });
                          const profileData = await profileRes.json();
                          console.log('[Signup] Profile DOB update result:', profileRes.status, profileData);
                        } catch (e) {
                          console.warn('[Signup] Profile DOB update failed:', e);
                        }

                        // Redirect to home
                        window.location.href = '/';
					} else {
            const msg = loginData?.message || 'Auto login failed';
						setErrors({ general: msg });
            openDialog('error', msg);
                        console.error("Auto login failed:", loginData.message);
                    }
                } else {
          console.error("Server validation errors:", data);
          // Update errors with server response (Laravel style)
          const laravelErrors = data?.errors;
          let msg = data?.message || 'Submission failed';
          if (laravelErrors && typeof laravelErrors === 'object') {
            const normalized = normalizeErrorObject(laravelErrors);
            const list = formatErrorList(normalized);
            setErrors({ ...normalized, general: list || msg });
            openDialog('error', list || msg);
          } else {
            setErrors({ general: msg });
            openDialog('error', msg);
          }
                }
            } catch (error) {
                console.error("Error during signup:", error);
        setErrors({ general: "Network error, please try again" });
        openDialog('error', 'Network error, please try again');
            }
        } else {
            console.log("Form has errors. Please fix them and try again.");
      const msg = formatErrorList(errors) || 'Please fix the highlighted errors and try again.';
      openDialog('error', msg);
      console.error(errors)
        }
    };
    
        const [logo, setLogo] = useState([]);
        useEffect(() => {
            const fetchPromotions = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
                    if (!response.ok) {
                        throw new Error("Failed to fetch promotions");
                    }
                    const data = await response.json();
                    setLogo(data[0].logo);
                } catch (error) {
                    console.error("Error fetching promotions:", error);
                }
            };
    
            fetchPromotions();
        }, []);
    
  return (
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done" style={{position:'relative', zIndex:1}}>
  {/* Background image with 20% opacity */}
  <div
    aria-hidden="true"
    style={{
      position: 'fixed',
      inset: 0,
      background: 'url(/poster/login.jpeg) center/cover no-repeat',
      opacity: 0.2,
      zIndex: 0,
      pointerEvents: 'none'
    }}
  />
  <div className="_container_box">
    <div className="form-page-container login-container">
      <Link to={"/"} className="page-goback">
        <svg className="am-icon am-icon-icon-return_456bcff4 am-icon-md icon-return"><use xlinkHref="#icon-return_456bcff4" /></svg>
      </Link>
      <div className="form-wrap">
        <form className="form-content" onSubmit={handleSubmit}>
          <div className="outter-form">
            <div className="login-form-bg">
              <div className="form-header"><img className="common-logo form-logo" src={`${process.env.REACT_APP_API_URL}/storage/${logo}`} alt="Logo" /></div>
              <div className="form-title"><h5>SignUp</h5></div>
              {errors.general && (
                <div className="panel panel-default" style={{background:'#2a1215', border:'1px solid #5c1f26', borderRadius:8, padding:'8px 10px', color:'#ffb4b4', marginBottom:8}}>
                  <p style={{whiteSpace:'pre-wrap', margin:0}}>{errors.general}</p>
                </div>
              )}
              <div className="form-group">
                <div className="fixed-list"><input type="text" className="form-control" value={formData.username}
                                                onChange={handleChange} name="username" placeholder="Username" autoComplete="off" /></div>
                <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.username}</p></div>
              </div>
              
              <div className="form-group">
                <div className="fixed-list"><input type="tel" className="form-control" value={formData.phone}
                                                onChange={handleChange} name="phone" placeholder="Mobile" autoComplete="off" /></div>
                <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.phone}</p></div>
              </div>
              {isTk24 && (
                <div className="form-group">
                  <div className="fixed-list">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.agent_code}
                      onChange={handleChange}
                      name="agent_code"
                      placeholder="Referral Code"
                      autoComplete="off"
                    />
                  </div>
                  <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.agent_code}</p></div>
                </div>
              )}
              <div className="form-group">
                <div className="fixed-list">
                  <input   type={passwordShown ? "text" : "password"} autoComplete="off" className="form-control"  value={formData.password}
                                                onChange={handleChange} name="password" placeholder="Password" />
                  <span  onClick={togglePasswordVisibility} className="right-icon">
                    {passwordShown ? (
                        
                        <svg className="am-icon am-icon-eye-open_4d0eeb46 am-icon-md">
                            <use xlinkHref="#eye-open_4d0eeb46" />
                        </svg>
                        ) : (
                        
                        <svg className="am-icon am-icon-eye-closed_edeafb54 am-icon-md">
                            <use xlinkHref="#eye-closed_edeafb54" />
                        </svg>
                        )}
                  </span>
                </div>
                <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.password}</p></div>
                {/* Password validation rules */}
                <div style={{
                  background: 'rgba(0, 0, 0, 0.4)',
                  border: '2px solid #00c853',
                  borderRadius: '8px',
                  padding: '12px 14px',
                  marginTop: '10px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <input type="checkbox" checked={passwordRules.hasUppercase && passwordRules.hasLowercase && passwordRules.hasNumber && passwordRules.hasMinLength} readOnly style={{ width: '18px', height: '18px', marginRight: '10px', accentColor: '#00c853' }} />
                    <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>পাসওয়ার্ডে থাকতে হবে:</span>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px', paddingLeft: '4px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px', flexShrink: 0, marginTop: '2px' }}>
                      <path d={passwordRules.hasUppercase ? "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" : "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"} fill={passwordRules.hasUppercase ? "#00c853" : "#888"} />
                    </svg>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: passwordRules.hasUppercase ? '#00c853' : '#888', fontSize: '13px' }}>১টি বড় হাতের অক্ষর</span>
                      <span style={{ color: '#aaa', fontSize: '12px' }}>At least 1 Uppercase letter (A-Z)</span>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px', paddingLeft: '4px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px', flexShrink: 0, marginTop: '2px' }}>
                      <path d={passwordRules.hasLowercase ? "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" : "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"} fill={passwordRules.hasLowercase ? "#00c853" : "#888"} />
                    </svg>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: passwordRules.hasLowercase ? '#00c853' : '#888', fontSize: '13px' }}>১টি ছোট হাতের অক্ষর</span>
                      <span style={{ color: '#aaa', fontSize: '12px' }}>At least 1 Lowercase letter (a-z)</span>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px', paddingLeft: '4px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px', flexShrink: 0, marginTop: '2px' }}>
                      <path d={passwordRules.hasNumber ? "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" : "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"} fill={passwordRules.hasNumber ? "#00c853" : "#888"} />
                    </svg>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: passwordRules.hasNumber ? '#00c853' : '#888', fontSize: '13px' }}>১টি সংখ্যা</span>
                      <span style={{ color: '#aaa', fontSize: '12px' }}>At least 1 Number (0-9)</span>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px', paddingLeft: '4px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px', flexShrink: 0, marginTop: '2px' }}>
                      <path d={passwordRules.hasMinLength ? "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" : "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"} fill={passwordRules.hasMinLength ? "#00c853" : "#888"} />
                    </svg>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: passwordRules.hasMinLength ? '#00c853' : '#888', fontSize: '13px' }}>কমপক্ষে ৮ অক্ষর</span>
                      <span style={{ color: '#aaa', fontSize: '12px' }}>Minimum 8 characters</span>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingTop: '4px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>💡</span>
                    <span style={{ color: '#ffd700', fontSize: '13px' }}>উদাহরণ: Example: <strong>Abc12345</strong></span>
                  </div>
                </div>
              </div>
              <div className="form-checkbox-wrap">
                <div className="sm-checkbox-item sm-checkbox-item-select">
                  <i className="sm-checkbox-item-bg" />
                  <div className="sm-label"><p>Remember</p></div>
                </div>
                <div className="forget-password">
                  <a href="#" onClick={(e)=>{e.preventDefault(); setShowForgot(true);}}>Forgot password?</a>
                </div>
              </div>
              <button type="submit" className="submit-btn login-btn"><span>Next</span></button>
              <div className="social-media-login">
                <div className="tips"><span>or connect with</span></div>
                <div className="item-group">
                  <div className="item facebook">
                    <svg className="am-icon am-icon-facebook_8e3e8cca am-icon-md"><use xlinkHref="#facebook_8e3e8cca" /></svg><span>Facebook</span>
                  </div>
                  <div className="item google">
                    <svg className="am-icon am-icon-google_69d0ac58 am-icon-md"><use xlinkHref="#google_69d0ac58" /></svg><span>Google</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <input
                name="agent_code"
                type="hidden"
                value={formData.agent_code}    
            />
            <input
              name="referral_code"
              type="hidden"
              value={formData.referral_code}    
          />
        </form>
      </div>
    </div>
    
  </div>
  {dialog.open && (
    <div
      role="dialog"
      aria-live="assertive"
      aria-modal="true"
      onClick={closeDialog}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
      }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{
        width: '88%', maxWidth: 420, background: '#101214', color: '#fff',
        borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
        padding: 16, border: dialog.type === 'error' ? '1px solid #ff6666' : '1px solid #22c55e'
      }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom: 8 }}>
          <span style={{
            width: 10, height: 10, borderRadius: '50%',
            background: dialog.type === 'error' ? '#ff6666' : dialog.type === 'success' ? '#22c55e' : '#60a5fa'
          }}/>
          <strong>{dialog.type === 'error' ? 'Error' : dialog.type === 'success' ? 'Success' : 'Notice'}</strong>
        </div>
        <pre style={{ whiteSpace:'pre-wrap', margin: 0, fontFamily: 'inherit' }}>{dialog.message}</pre>
        <div style={{ display:'flex', justifyContent:'flex-end', marginTop: 12 }}>
          <button onClick={closeDialog} style={{
            background:'#22c55e', color:'#fff', border:0, borderRadius:8, padding:'8px 14px', cursor:'pointer'
          }}>OK</button>
        </div>
      </div>
    </div>
  )}
  <ForgotPasswordModal
    open={showForgot}
    onClose={()=>setShowForgot(false)}
    showAlert={(msg)=>openDialog('info', msg)}
    theme="dark"
  />
</div>
  );
}

export default MobileSiginUp;